const ArrowDownIcon = ({ style = {}, color = 'currentColor', height = '24px', width = '24px' }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style={style}
			width={width}
			height={height}
			fill="none"
			viewBox="0 0 24 24"
			stroke={color}
			strokeWidth="1.5"
		>
			<path d="M5.99977 9.00005L11.9998 15L17.9998 9" strokeMiterlimit="16" />
		</svg>
	);
};

export default ArrowDownIcon;
